import { useParams } from "react-router-dom";
import Exam from "../../component/azmoon-list/Exam";
import MobileExam from "../../component/mobile/azmoon-list/M_Exam";

const ExamView = () => {
  const { id } = useParams();

  return (
    <div className="EXAM">
      {window.innerWidth > 1000 && <Exam ID={id} />}
      {window.innerWidth < 1000 && <MobileExam ID={id} />}
    </div>
  );
};

export default ExamView;
